package one.healthium.log_food.ui.navigation.scan_results

import com.arkivanov.decompose.ComponentContext
import one.healthium.profile.ui.food.models.FoodUiModel

class DefaultScanResultsComponent(
    componentContext: ComponentContext,
    override val foods: List<FoodUiModel>,
    private val onFoodAdded: () -> Unit,
) : ScanResultsComponent, ComponentContext by componentContext {
    override fun onFoodAdded() {
        onFoodAdded.invoke()
    }
}
